import ReactDOM from "react-dom/client"
import "react-intl-tel-input-18/dist/main.css"
import "simplebar-react/dist/simplebar.min.css"
import { App } from "./App"
import "./style.css"
// import 'bootstrap/dist/css/bootstrap.css';
// import reportWebVitals from '@/reportWebVitals'

ReactDOM.createRoot(document.getElementById("root")!).render(<App />)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.info))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals()
